import { api } from "../api"

const PERSONAL_VIDEO_ID = "6925a94269ff8ba4438fee25"
const ORG_VIDEO_ID = "6925ac7e69ff8ba4438fee27"
const COLLABORATION_VIDEO_ID = "6925aad769ff8ba4438fee26"
const VIDEO_API_URL = "https://admin.starbrix.app/get-help-videos"

const VIDEO_ID_MAP = {
  personal: PERSONAL_VIDEO_ID,
  organisational: ORG_VIDEO_ID,
  collaboration: COLLABORATION_VIDEO_ID,
} as const

export const helpVideoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getHelpVideo: builder.query<any[], void>({
      queryFn: async () => {
        try {
          const response = await fetch(VIDEO_API_URL)
          if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`)

          const data = await response.json()
          return { data }
        } catch (error) {
          let errorMessage = "An unknown error occurred"
          if (error instanceof Error) errorMessage = error.message
          return { error: { status: 500, data: [{ code: "fetch_error", message: errorMessage }] } }
        }
      },
    }),
  }),
})

export const useHelpVideo = (type: keyof typeof VIDEO_ID_MAP) => {
  const { data: videos = [], error, isLoading, isError } = helpVideoApi.useGetHelpVideoQuery()

  const videoId = VIDEO_ID_MAP[type]
  const video = videos.find((v: any) => v.id === videoId) || null

  return {
    isLoading,
    isError,
    error,
    video,
  }
}
